import React from 'react'
import { checkTextTranslation, checkTranslation } from '../../utils/useful'
import inputComponents from './inputComponents'
import { TypeToInputType } from '../../variables/formBuilderData'

class DynamicInput extends React.Component {
    state = {
        inputType: null
    }

    componentDidMount() {
        this.selectType(true)
    }

    componentDidUpdate(prevProps) {

        let info = this.props.header?.information

        if (info?.inputType != this.state.refInputType) {
            this.selectType()
        }
    }


    selectType = (init) => {

        let info = this.props.header?.information
        let inputType


        if (!init && this.state.refInputType) {
            this.changeValue(null, null)
        }

        this.setState({ refInputType: info.inputType })
        if (info.inputType) {
            inputType = TypeToInputType[info.inputType.toLowerCase()]
        }


        this.setState({ inputType })

    }




    changeValue = (key, value, extra) => {

       
        this.props.changeValue(this.props.header.key, value, this.props.extra)

    }





    render() {

        let Component = inputComponents[this.state.inputType]

        return (
            <div className="w-100 h-100 flexc text-start"  >
                {Component && (
                    <Component header={this.props.header} data={this.props.data} changeValue={this.changeValue} params={this.props.params} variables={this.props.variables} width={this.props.width} />
                )}
            </div>
        )
    }
}

export default DynamicInput;